export const GPT_MODEL_01_MINI = 'o1-mini';
export const GPT_MODEL_4O_2024_05_13 = 'gpt-4o-2024-05-13';
export const GPT_MODEL_4O_2024_08_06 = 'gpt-4o-2024-08-06';
export const GPT_MODEL_4O_2024_11_20 = 'gpt-4o-2024-11-20';

export const gptModelLabels = {
  [GPT_MODEL_4O_2024_05_13]: 'GPT-4o 2024-05-13',
  [GPT_MODEL_4O_2024_08_06]: 'GPT-4o 2024-08-06',
  [GPT_MODEL_4O_2024_11_20]: 'GPT-4o 2024-11-20',
};